// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2141":"2e9276082f952346","4112":"a3ede44e6a0beb25","5735":"6d7a78ca153b42c1","8787":"a1e3a7d3afb0d21c"}[chunkId] + ".css";
};